import React from 'react';
import { Row, Col, Button } from 'antd';
import { Label } from 'components';

const PageLabeledButton = ({ labelMessage, pageName, buttonTitle, buttonAction }) => {
  return (
    <Row className={`${pageName}-wrapper-row`}>
      <Col span={24} className={`${pageName}-wrapper-col`}>
      <Label
          label={labelMessage}
          labelClassName={`page-title-label ${pageName}-title-label`}
        />
        <Button
          type="primary"
          className="submit-component"
          onClick={ event => { buttonAction(event); } }
          >{buttonTitle}</Button>
      </Col>
    </Row>
  );
};

export default PageLabeledButton;